<template>
  <div class="nkn-partners">
    <!--<div class="common-sub-title">{{$t("partner.list.title")}}</div>-->
    <div class="partners-group">
      <div class="partners-group-inner">
        <div class="common-sub-title">{{$t("partner.list.telco.title")}}</div>
        <div class="partners-group-content">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.chinaMobile">
                <img
                  v-lazy="'/static/img/partner/list/iQIYI.png'"
                  class="pic-telco-iQIYI"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.iQIYI.title")}}</span>
                <p slot="partner-intro">{{$t("partner.list.iQIYI.text")}}</p>
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.chinaMobile">
                <img
                  v-lazy="'/static/img/partner/list/ChinaMobile.png'"
                  class="pic-telco-china-mobile"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.chinaMobile.title")}}</span>
                <p slot="partner-intro">{{$t("partner.list.chinaMobile.text")}}</p>
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.netnic">
                <img
                  v-lazy="'/static/img/partner/list/NetNIC.png'"
                  class="pic-telco-netnic"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.netnic.title")}}</span>
                <p slot="partner-intro">{{$t("partner.list.netnic.text")}}</p>
              </partner-module>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.TIP">
                <img
                  v-lazy="'/static/img/partner/list/telecom.png'"
                  class="pic-telco-telecom"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.telco.tipTitle")}}</span>
                <p slot="partner-intro">{{$t("partner.list.telco.tipText")}}</p>
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.ONF">
                <img
                  v-lazy="'/static/img/partner/list/ONF.png'"
                  class="pic-telco-ONF"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.telco.onfTitle")}}</span>
                <p slot="partner-intro">{{$t("partner.list.telco.onfText")}}</p>
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.datapace">
                <img
                  v-lazy="'/static/img/partner/list/datapace.png'"
                  class="pic-telco-datapace"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.telco.dpTitle")}}</span>
                <p slot="partner-intro">{{$t("partner.list.telco.dpText")}}</p>
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.nokia">
                <img
                  v-lazy="'/static/img/partner/list/nokia.png'"
                  class="pic-blockchain-nokia"
                  slot="partner-logo"
                />
                <a
                  slot="partner-name"
                  :href="$url.PARTNER.nokia"
                  target="_blank"
                >{{$t("partner.list.equipment.nokiaTitle")}}</a>
                <p slot="partner-intro">{{$t("partner.list.equipment.nokiaText")}}</p>
              </partner-module>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partners-group">
      <div class="partners-group-inner">
        <div class="common-sub-title">{{$t("partner.list.cloud.title")}}</div>
        <div class="partners-group-content">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child">
                <img
                  v-lazy="'/static/img/partner/list/googlecloud.png'"
                  class="pic-cloud-googlecloud"
                  slot="partner-logo"
                />
                <a
                  slot="partner-name"
                  :href="$url.PARTNER.googleCloud"
                  target="_blank"
                >{{$t("partner.list.cloud.gcTitle")}}</a>
                <p slot="partner-intro">{{$t("partner.list.cloud.gcText")}}</p>
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child">
                <img
                  v-lazy="'/static/img/partner/list/DigitalOcean.png'"
                  class="pic-cloud-DigitalOcean"
                  slot="partner-logo"
                />
                <a
                  slot="partner-name"
                  :href="$url.PARTNER.DigitalOcean"
                  target="_blank"
                >{{$t("partner.list.cloud.dcTitle")}}</a>
                <p slot="partner-intro">{{$t("partner.list.cloud.dcText")}}</p>
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child">
                <img
                  v-lazy="'/static/img/partner/list/AWS.png'"
                  class="pic-cloud-AWS"
                  slot="partner-logo"
                />
                <a
                  slot="partner-name"
                  :href="$url.PARTNER.AWS"
                  target="_blank"
                >{{$t("partner.list.cloud.awsTitle")}}</a>
                <p slot="partner-intro">{{$t("partner.list.cloud.awsText")}}</p>
              </partner-module>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partners-group">
      <div class="partners-group-inner">
        <div class="common-sub-title">{{$t("partner.list.developer.title")}}</div>
        <div class="partners-group-content">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.portalNetwork">
                <img
                  v-lazy="'/static/img/partner/list/portal.png'"
                  class="pic-developer-portal"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.developer.pnTitle")}}</span>
                <!--<p slot="partner-intro">{{$t("partner.list.developer.pnText")}}</p>-->
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.O3">
                <img
                  v-lazy="'/static/img/partner/list/O3.png'"
                  class="pic-developer-O3"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.developer.o3Title")}}</span>
                <!--<p slot="partner-intro">{{$t("partner.list.developer.o3Text")}}</p>-->
              </partner-module>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.W3I">
                <img
                  v-lazy="'/static/img/partner/list/w3i.png'"
                  class="pic-developer-w3i"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.developer.w3iTitle")}}</span>
              </partner-module>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partners-group">
      <div class="partners-group-inner">
        <div class="common-sub-title">{{$t("partner.list.research.title")}}</div>
        <div class="partners-group-content">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4">
              <partner-module class="partners-group-child" :link="$url.PARTNER.cryptic">
                <img
                  v-lazy="'/static/img/partner/list/cryptic.png'"
                  class="pic-research-cryptic"
                  slot="partner-logo"
                />
                <span slot="partner-name">{{$t("partner.list.research.crypticTitle")}}</span>
                <p slot="partner-intro">{{$t("partner.list.research.crypticText")}}</p>
              </partner-module>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PartnerModule from "@/components/partner/plugins/PartnerModule";
export default {
  components: {
    PartnerModule
  }
};
</script>

<style lang="scss" scoped>
.nkn-partners {
  .partners-group:nth-child(even) {
    background-color: #f9faff;
  }
  .partners-group {
    width: 100%;
    .partners-group-inner {
      @include common-inner();
    }

    &-title {
      @include nkn-font-set(0.9rem, $common-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partner/nknPartners.vue